import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const oan = {
    jpath: ['spectra', 'oan'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default oan;
//# sourceMappingURL=oan.js.map